export enum EPresentation {
  VALUE = "VALUE",
  ENUM = "ENUM",
  BITFIELD = "BITFIELD",
  ACCUMULATED = "ACCUMULATED",
}
